<template>
    <v-layout row wrap>
        <v-flex xs12 class="comment-list">
            <add-comment v-if="canComment && !isAdminPageFeed && commentList && commentList.length > 0"
                         :parent-id="parentPostId"
                         :comment-count-value="commentCountValue">
            </add-comment>
            <v-layout align-center justify-center v-if="!canComment">
                <v-flex xs8 class="comment-list__disabled-comment-text" data-qe-id="comment_disabled_statement">
                    {{communityCommonConstant.post.COMMENTS_HAS_BEEN_DISABLED}}
                </v-flex>
            </v-layout>
            <div v-if="commentList && commentList.length > 0">
                <component
                    v-for="comment in commentList"
                    :key="comment.id"
                    :is="componentTypeFor(comment)"
                    v-bind="componentPropsFor(comment)"></component>
                <v-flex
                    xs12
                    class="show-more-link text-xs-right"
                    id="show_more_comments_link"
                    v-if="displayShowMoreComment"
                    data-qe-id="show_more_comments_link"
                    @click="loadMoreComments({postId: parentPostId, isAdminPageFeed})">
                    {{communityCommonConstant.post.SHOW_MORE_COMMENTS}}
                </v-flex>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
    import Comment from './Comment';
    import PostEditor from '../PostEditor/PostEditor';
    import { mapGetters, mapActions } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { storeAction } from '../../../store/storeActions.constant';
    import AddPost from '../AddPost/AddPost';
    import AddComment from '../AddComment/AddComment';
    import { communityCommonConstant } from '../communityCommon.constant';
    import HiddenComment from '../HiddenComment/HiddenComment.vue';

    export default {
        name: 'CommentList',
        data: () => ({
            communityCommonConstant,
        }),

        props: {
            commentList: {
                type: Array,
                required: true,
            },
            parentPostId: {
                type: String,
                required: true,
            },
            commentCountValue: {
                type: Number,
                required: true,
            },
            isAdminPageFeed: {
                type: Boolean,
                default: false,
            },
            canComment: {
                type: Boolean,
                required: true,
            },
            canEditAllActivityFeed: {
                type: Boolean,
                required: true, 
            },
            inappropriateChildren: {
                type: Number,
                required: true,
            },
        },
        components: {
            AddComment,
            AddPost,
            Comment,
            PostEditor,
            HiddenComment,
        },
        methods: {
            ...mapActions({
                loadMoreComments: `chapter/${storeAction.getMoreCommentsForPost}`,
            }),
            componentTypeFor(comment) {
                // Disabling lint rule since this is a simple expression and operator precedence
                // is not a concern, so I think this is easy to understand as-is.

                // eslint-disable-next-line no-nested-ternary
                return this.isPostEditing(comment.id) ?
                    'PostEditor' :
                    this.isHiddenPost(comment.id) ?
                    'HiddenComment' :
                    'Comment';
            },
            componentPropsFor(comment) {
                return this.isPostEditing(comment.id) ? {
                    post: comment,
                } : {
                    comment,
                    canReply: this.canComment,
                    canEditAllActivityFeed: this.canEditAllActivityFeed,
                    isAdminPageComment: this.isAdminPageFeed,
                };
            },
        },
        computed: {
            ...mapGetters('chapter', [storeGetters.isPostEditing, storeGetters.isHiddenPost]),
            displayShowMoreComment() {               
                if (this.isAdminPageFeed) {
                    return this.inappropriateChildren && this.commentList ? this.inappropriateChildren > this.commentList.length : false;
                }
                return this.commentCountValue && this.commentList ? this.commentCountValue > this.commentList.length : false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .comment-list {
        position: relative;
        z-index: 1;

        &__disabled-comment-text {
            background-color: $white;
            padding: 10px;
            border: 1px solid $ypo-gray;
            text-align: center;
            border-radius: 4px;
            margin-bottom: 10px;
        }

    }

    .show-more-link {
        cursor: pointer;
        color: $ypo-title-blue;
        margin: 0px 30px 15px 0;
        font-size: 12px;

        &:hover {
            color: $ypo-blue;
        }
    }
</style><style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .comment-list {
        .post-editor .v-textarea>.v-input__control>.v-input__slot textarea {
            margin: 0 !important;
        }

        .post-editor__content {
            background: transparent;
        }

        .post-editor {
            margin: 10px;
            @include breakpoint(xs) {
                margin: 0px;
            }
        }

        .v-textarea {
            margin: -8px;
        }

        .post__Allow_Comments {
            background: $white;

            .v-btn {
                margin: 0 0px 0 10px !important;
            }
        }

        textarea {
            resize: none;
        }

    }
</style>
